import { useAuthContext } from "providers/Auth";
import { Links } from "./constants";
import { PropertyManagementSystem } from "shared/types/partner";

export const shouldShowGlobalLink = (
  name: string,
  type: ReturnType<typeof useAuthContext>["type"]
) => {
  // Hide Tasks link for non BoomCRM users
  if (name === Links.TASKS) return type.isBoomCRM;

  const isBlockedPropertyGroup =
    (type.isPropertyManager || !type.isBoomScreen) &&
    name === Links.PROPERTY_GROUPS;

  return !isBlockedPropertyGroup;
};

export const shouldShowReportingLinks = (
  name: string,
  type: ReturnType<typeof useAuthContext>["type"],
  partner: ReturnType<typeof useAuthContext>["partner"]
) => {
  const isAppfolio =
    partner?.property_management_system?.name ===
    PropertyManagementSystem.Appfolio;

  const isBlockedRenter =
    name === Links.RENTERS &&
    (!type.isPMS || (type.isBoomScreen && !type.isRentReporting) || isAppfolio);

  return !isBlockedRenter;
};
